import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { X } from "lucide-react";

const MonthPicker = ({ onDateChange, intiStartDate, intiEndDate, isDark = false }) => {
  console.log(intiStartDate, intiEndDate);
  const [dateRange, setDateRange] = useState([intiStartDate, intiEndDate]);
  const [startDate, endDate] = dateRange;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleDateChange = (update) => {
    setDateRange(update);
    if (update[0] && update[1]) {
      // Only call the callback when both dates are selected
      if (onDateChange) {
       
        onDateChange(update[0], update[1]);
      }
      setIsOpen(false);
    }
  };

  const clearDateRange = (e) => {
    if (e) e.stopPropagation();
    setDateRange([null, null]);
    if (onDateChange) onDateChange(null, null);
  };

  const formatDateDisplay = (date) => {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const formatDateDisplayNew = (date) => {
    if (!date) return '';
    const day = date.getDate();
    const getDaySuffix = (day) => {
      if (day >= 11 && day <= 13) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    const month = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
    const year = date.getFullYear();
    return `${day}${getDaySuffix(day)} ${month} ${year}`;
  };

  return (
    <div className="datepicker relative" ref={dropdownRef}>
      <div className="relative">
        <div
          className={`h-[40px] rounded-[12px] px-[16px] py-[6px] flex items-center gap-[10px] cursor-pointer transition-colors duration-200 border-solid border-[1px] ${
            isDark ? 'bg-[#161515] border-[#292929]' : 'bg-white border-[#d9d9d9]'
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div
            className="w-[14px] h-[14px] shrink-0"
            style={{
              backgroundColor: isDark ? '#b3b3b3' : '#072837',
              WebkitMaskImage: "url('/assets/icons/calendar.svg')",
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskSize: 'contain',
              WebkitMaskPosition: 'center',
              maskImage: "url('/assets/icons/calendar.svg')",
              maskRepeat: 'no-repeat',
              maskSize: 'contain',
              maskPosition: 'center'
            }}
            aria-hidden="true"
          />
          <span className={`flex-1 overflow-hidden text-ellipsis font-normal text-[16px] whitespace-nowrap transition-colors duration-200 ${
            isDark ? 'text-[#b3b3b3]' : 'text-[#072837]'
          }`}>
            {startDate && endDate
              ? `${formatDateDisplay(startDate)} - ${formatDateDisplay(endDate)}`
              : "Select Date Range"}
          </span>
          {(startDate || endDate) && (
            <button
              className="ml-auto p-0 bg-transparent border-0 cursor-pointer shrink-0"
              onClick={clearDateRange}
            >
              <X className={`w-[14px] h-[14px] transition-colors duration-200 ${
                isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
              }`} strokeWidth={2} />
            </button>
          )}
        </div>

        {/* Tailwind Dropdown */}
        {isOpen && (
          <div className="absolute top-full left-0 right-0 mt-[8px] z-[100000]">
            <DatePicker
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              onChange={handleDateChange}
              inline
            />
            {startDate && endDate && (
              <div className="flex justify-between gap-[8px] mt-[8px]">
                <button
                  className="flex-1 bg-white text-[#686868] border border-[#d9d9d9] rounded-[8px] px-[16px] py-[8px] text-[14px] font-medium hover:bg-gray-50 transition-colors cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDateRange([null, null]);
                    if (onDateChange) onDateChange(null, null);
                  }}
                >
                  Clear
                </button>
                <button
                  className="flex-1 bg-[#cd6d2c] text-white rounded-[8px] px-[16px] py-[8px] text-[14px] font-medium hover:bg-[#b85f24] transition-colors cursor-pointer border-0"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(false);
                  }}
                >
                  Apply
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MonthPicker;
